import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Le mot de passe doit contenir au moins 6 caractères");
      return;
    }
    if (password !== confirm) {
      toast.error("Les mots de passe ne correspondent pas");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Mot de passe réinitialisé");
      setTimeout(() => nav("/login"), 2500);
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-[calc(100vh-64px)] flex items-center justify-center p-8">
        <div className="max-w-md text-center" data-testid="reset-invalid">
          <h1 className="font-display text-4xl uppercase">Lien invalide</h1>
          <p className="mt-4 text-white/60">Ce lien de réinitialisation est invalide ou incomplet.</p>
          <Link to="/mot-de-passe-oublie" className="mt-6 inline-block text-[#FF3B00] uppercase tracking-widest text-sm">
            Demander un nouveau lien
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center justify-center p-8">
      <div className="w-full max-w-md" data-testid="reset-password-page">
        <div className="text-xs uppercase tracking-[0.3em] text-[#FF3B00]">Nouveau mot de passe</div>
        <h1 className="font-display text-5xl uppercase mt-2 leading-none">Sécurisez.</h1>

        {!done ? (
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="reset-form">
            <div>
              <label className="text-xs uppercase tracking-widest text-white/60">Nouveau mot de passe</label>
              <input
                data-testid="reset-password"
                type="password"
                required
                minLength={6}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full mt-1 bg-transparent border border-white/20 focus:border-[#FF3B00] outline-none px-4 py-3"
              />
              <div className="text-xs text-white/40 mt-1">Minimum 6 caractères</div>
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-white/60">Confirmer le mot de passe</label>
              <input
                data-testid="reset-confirm"
                type="password"
                required
                minLength={6}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                className="w-full mt-1 bg-transparent border border-white/20 focus:border-[#FF3B00] outline-none px-4 py-3"
              />
            </div>
            <button
              data-testid="reset-submit"
              disabled={loading}
              className="w-full py-4 bg-[#FF3B00] text-white uppercase tracking-widest hover:bg-[#E03500] disabled:opacity-50"
            >
              {loading ? "..." : "Confirmer"}
            </button>
            <div className="text-sm text-white/60 text-center">
              <Link to="/login" className="text-[#FF3B00]">Annuler</Link>
            </div>
          </form>
        ) : (
          <div className="mt-8 border border-white/20 p-6" data-testid="reset-success">
            <p className="text-white/90 leading-relaxed">
              Votre mot de passe a été réinitialisé avec succès. Redirection vers la connexion...
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
